export const SNAPPER_CARD_PREFIX = "10100000";
export const SNAPPER_CARD_NUMBER_LENGTH = 16;
export const SNAPPER_CVV_LENGTH = 3;

export function normalizeSnapperCardNumber(value) {
  if (typeof value !== "string") {
    return null;
  }

  const normalized = value.replace(/[ -]/g, "");
  return /^\d+$/.test(normalized) ? normalized : null;
}

export function isValidSnapperCardNumber(value) {
  const cardNumber = normalizeSnapperCardNumber(value);

  if (
    !cardNumber ||
    cardNumber.length !== SNAPPER_CARD_NUMBER_LENGTH ||
    !cardNumber.startsWith(SNAPPER_CARD_PREFIX)
  ) {
    return false;
  }

  const luhnDigits = cardNumber.substring(6);
  let sum = 0;
  let shouldDouble = false;

  for (let index = luhnDigits.length - 1; index >= 0; index -= 1) {
    let digit = Number(luhnDigits[index]);

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
}

export function isValidSnapperCvv(value) {
  return (
    typeof value === "string" &&
    new RegExp(`^\\d{${SNAPPER_CVV_LENGTH}}$`).test(value)
  );
}
